<template>
  <div class="remote">
    <div class="headCarName">
      <i class="el-icon-setting"></i>&nbsp;&nbsp;远程接管&nbsp;&nbsp;&nbsp;&nbsp;<font size="2px">当前车辆ID：{{carId}}</font>
    </div>
    <div class="videoRow">
      <!-- 视频模块 -->
      <div class="videos">
        <!-- <div class="vjs-custom-skin">
                 <video id="myVideo"
                   class="video-js vjs-default-skin vjs-big-play-centered"
                   controls
                   autoplay= "muted"
                   preload="auto"
                   style="width: 1000px;height:300px;margin-left: 300px;"
                   >
                     <source src="../assets/flv/mmexport1618891041644.mp4" type="video/mp4" >
                  </video>
                 </div> -->

        <!-- <span id="video1"> -->
        <video id="videoElement1" class="centeredVideo" autoplay width="350" height="300">Your browser is too old which
          doesn't support HTML5 video.</video>
        <!-- </span> -->
        <video id="videoElement0" class="centeredVideo" autoplay width="350" height="300">Your browser is too old which
          doesn't support HTML5 video.</video>
        <!-- <span id="video2"> -->
        <!-- <video id="videoElement2" class="centeredVideo" autoplay width="350" height="300">Your browser is too old which
          doesn't support HTML5 video.</video> -->
        <!-- </span> -->

      </div>
      <div style="margin-top: 20px;">
        <el-button @click="openOrClose" type="success">{{isOpen?"关闭":"开启"}}</el-button>
        <el-button @click="refreshVideo" type="success">刷新</el-button>
      </div>

    </div>
    <div class="controlRow">
      <!-- 控制模块 -->
      <el-row :gutter="20">
        <el-col :span="8">
          <div>
            <div class="joy" style="width:100%;height:300px">
              <div id="joy-control" style="width:100%;height:300px;"></div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="show">
            <!-- 展示区 -->
            <el-form ref="form" :model="show" label-width="80px">
              <el-form-item label="原始角度">
                <el-input v-model="show.degree" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="方向角度">
                <el-input v-model="show.angle" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="速度级别">
                <el-input v-model="show.level" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="当前象限">
                <el-input v-model="show.quadrant" :disabled="true"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="controlForm">
            <!-- 控制开关 -->
            <el-form ref="controlForm" :model="controlForm" label-width="80px" size="mini">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="大灯" v-if="hasControlForm.light">
                    <el-switch v-model="controlForm.light" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>
                  <el-form-item label="喇叭" v-if="hasControlForm.trumpet">
                    <el-switch v-model="controlForm.trumpet" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>
                  <el-form-item label="洒水" v-if="hasControlForm.sprinkle">
                    <el-switch v-model="controlForm.sprinkle" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>
                  <el-form-item label="震尘" v-if="hasControlForm.shockDust">
                    <el-switch v-model="controlForm.shockDust" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>
                  <el-form-item label="扫地" v-if="hasControlForm.sweep">
                    <el-switch v-model="controlForm.sweep" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>
                  <el-form-item label="洗地" v-if="hasControlForm.washFloor">
                    <el-switch v-model="controlForm.washFloor" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="吸水" v-if="hasControlForm.absorptionWater">
                    <el-switch v-model="controlForm.absorptionWater" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>
                  <el-form-item label="安全防护" v-if="hasControlForm.security">
                    <el-switch v-model="controlForm.security" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import {
    rtmpControl
  } from '@/api/remote'
  import {
    remoteControl
  } from '@/api/remote'

  export default {
    name: "Remote",
    data() {
      return {

        /* playerOptions: {
                playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
                autoplay: false, // 如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [{
                  type: 'video/mp4', // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
                  src: '../assets/flv/20200821113120.flv' // url地址
                }],
                poster: '../assets/img/shoubing1.png', // 你的封面地址
                width: document.documentElement.clientWidth, // 播放器宽度
                notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                  timeDivider: true,
                  durationDisplay: true,
                  remainingTimeDisplay: false,
                  fullscreenToggle: true // 全屏按钮
                }
              }, */
        playerOptions: {
          playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
          autoplay: false, //如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [{
            src: '../assets/flv/20200821113120.mp4', // 路径
            type: 'video/map4' // 类型
          }, {
            src: '//path/to/video.webm',
            type: 'video/webm'
          }],
          poster: "../assets/img/shoubing1.png", //你的封面地址
          // width: document.documentElement.clientWidth,
          notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            fullscreenToggle: true //全屏按钮
          }
        },
        //--------------------------------

        carId: '',
        carType: '',
        isOpen: false,
        show: {
          degree: 0,
          angle: 0, //方向角度
          level: 0, //速度等级
          quadrant: 0, //象限
        },
        angleSend: 0, //方向角度
        levelSend: 0, //速度等级
        quadrantSend: 0, //象限
        lightFlag: 0, //大灯标记位
        securityFlag: 0, //安全模块
        sweepFlag: 0, //扫地车标记位
        controlForm: {
          light: false, //大灯
          trumpet: false, //喇叭
          sprinkle: false, //洒水
          shockDust: false, //震尘
          sweep: false, //扫地
          washFloor: false, //洗地
          absorptionWater: false, //吸水
          security: false, //安全防护
        },
        hasControlForm: {
          light: true, //大灯
          trumpet: true, //喇叭
          sprinkle: false, //洒水
          shockDust: false, //震尘
          sweep: false, //扫地
          washFloor: false, //洗地
          absorptionWater: false, //吸水
          security: false, //安全防护
        },
        timer: null,
        //视频相关
        // player:undefined,
        // flvPlayer:undefined,
        frontFlvPlayer: undefined,
        leftFlvPlayer: undefined,
        rightFlvPlayer: undefined,
        // playerFlag:undefined,
        //控制相关
        rocker: undefined,
      }
    },
    methods: {
      openOrClose() {
        rtmpControl(this.carId, this.isOpen ? "0" : "7").then(res => {
          if (res.result == "0") {
            this.$message({
              type: "success",
              message: res.message
            })
          } else {
            this.$message.error(res.message)
          }
        })
        if (this.isOpen) {
          this.close()
        } else {
          console.log("start")
          this.frontFlvPlayer = this.flv_create('0')
          this.leftFlvPlayer = this.flv_create('1')
          this.rightFlvPlayer = this.flv_create('2')
          this.flv_start(this.frontFlvPlayer, document.querySelector("#videoElement0"))
          this.flv_start(this.leftFlvPlayer, document.querySelector("#videoElement1"))
          this.flv_start(this.rightFlvPlayer, document.querySelector("#videoElement2"))
          this.rockerInit()
        }
        this.isOpen = !this.isOpen
      },
      refreshVideo() {
        let that = this
        if (typeof this.frontFlvPlayer != undefined) {
          if (this.frontFlvPlayer != null) {
            console.log("refresh")
            this.openOrClose()
            setTimeout(function() {
              that.openOrClose()
            }, 500)
          }
        }
      },
      flv_create(videoFlag) {
        if (flvjs.isSupported()) {
          return flvjs.createPlayer({
            type: 'flv',
            isLive: true,
            cors: true,
            url: 'http://localhost:9555/live?port=9012&app=live&stream=stream' + this.carId + "-" +
              videoFlag, //<==自行修改
            // url: 'http://admin.techinao.com:9090/static/flv/sample.flv',
          }, {
            enableWorker: true,
            enableStashBuffer: false,
            stashInitialSize: 128,
          })
        }
      },
      flv_start(flvPlayerItem, div_videoElement) {
        // this.player=document.querySelector("#videoElement")
        if (flvjs.isSupported()) {
          flvPlayerItem.attachMediaElement(div_videoElement)
          flvPlayerItem.load()
          flvPlayerItem.play()
        }
      },
      flv_destroy(flvPlayerItem) {
        if (typeof flvPlayerItem !== "undefined") {
          if (flvPlayerItem != null) {
            flvPlayerItem.unload();
            flvPlayerItem.detachMediaElement();
            flvPlayerItem.destroy();
            flvPlayerItem = null;
          }
        }
      },
      close() {
        console.log("close")
        this.flv_destroy(this.frontFlvPlayer)
        this.flv_destroy(this.leftFlvPlayer)
        this.flv_destroy(this.rightFlvPlayer)
        this.frontFlvPlayer = null
        this.leftFlvPlayer = null
        this.rightFlvPlayer = null
      },
      //------------------------------------------------------------------------------------------------------------
      rockerInit() {
        let joyCon = document.querySelector("#joy-control");
        let options = {
          mode: "static", // 'dynamic', 'static' or 'semi'
          size: 200,
          position: {
            left: "25%",
            top: "40%"
          }, //在容器内垂直居中显示
          zone: joyCon, //如果不提提供zone容器元素，那么默认动态生成的元素是注入在body中的。
          color: "blue"
        };
        this.rocker = nipplejs.create(options);
        this.bindNipple();
      },
      bindNipple() {
        let that = this
        this.rocker.on('start end', function(evt, data) {
          console.log("开始");
          console.log(data);
          that.httpNipple(0, 0);
        });
        this.rocker.on('move', function(evt, data) {
          console.log("移动");
          console.log(data);
          that.httpNipple(data.angle.degree, data.distance);
        });
      },
      httpNipple(degree, distance) {
        let angle = 0; //方向角度
        let level = 0; //速度等级
        let quadrant = 0; //象限

        if (0 < degree && degree <= 90) {
          quadrant = 1;
          angle = parseInt(90 - degree);
        } else if (90 < degree && degree <= 180) {
          quadrant = 4;
          angle = parseInt(90 - (180 - degree));
        } else if (180 < degree && degree <= 270) {
          quadrant = 3;
          angle = parseInt(90 - (degree - 180));
        } else if (270 < degree && degree <= 360) {
          quadrant = 2;
          angle = parseInt(90 - (360 - degree));
        } else {
          quadrant = 0;
          angle = 0;
        }

        if (0 < distance && distance <= 10) {
          level = 0;
        } else if (10 < distance && distance <= 20) {
          level = 1;
        } else if (20 < distance && distance <= 30) {
          level = 2;
        } else if (30 < distance && distance <= 40) {
          level = 3;
        } else if (40 < distance && distance <= 50) {
          level = 4;
        } else if (50 < distance && distance <= 60) {
          level = 5;
        } else if (60 < distance && distance <= 70) {
          level = 6;
        } else if (70 < distance && distance <= 80) {
          level = 7;
        } else if (80 < distance && distance <= 90) {
          level = 8;
        } else if (90 < distance && distance <= 100) {
          level = 9;
        } else {
          level = 0;
        }

        this.show.degree = parseInt(degree)
        this.show.angle = angle
        this.show.level = level
        this.show.quadrant = quadrant

        if (0 <= angle && angle <= 10) {
          angle = 0;
        }

        this.angleSend = angle; //下发方向角度
        this.levelSend = level; //下发速度等级
        this.quadrantSend = quadrant; //下发象限
      },
      remoteIntevel() {
        //定时发送任务
        let that = this
        this.timer = setInterval(function() //开启循环：每秒出现一次提示框
          {
            that.changeControlFlag()
            remoteControl(that.carId, that.quadrantSend, that.angleSend, that.levelSend, that.lightFlag, that
              .sweepFlag, that.securityFlag).then(data => {
              if (data.result == 0) {
                console.log("ccu操作成功！");
              } else {
                console.log("ccu操作失败！");
              }
            })
          }, 500);
      },
      changeControlFlag() {
        console.log(this.controlForm)
        this.lightFlag = 0
        if (this.hasControlForm.light && this.controlForm.light) {
          this.lightFlag = 1
        }
        if (this.hasControlForm.security && this.controlForm.security) {
          this.securityFlag = 1
        }
        this.sweepFlag = 255
        if (this.hasControlForm.trumpet && this.controlForm.trumpet) {
          this.sweepFlag = this.sweepFlag ^ (1 << 7)
        }
        if (this.hasControlForm.sprinkle && this.controlForm.sprinkle) {
          this.sweepFlag = this.sweepFlag ^ (1 << 6)
        }
        if (this.hasControlForm.shockDust && this.controlForm.shockDust) {
          this.sweepFlag = this.sweepFlag ^ (1 << 5)
        }
        if (this.hasControlForm.sweep && this.controlForm.sweep) {
          this.sweepFlag = this.sweepFlag ^ (1 << 4)
        }
        if (this.hasControlForm.washFloor && this.controlForm.washFloor) {
          this.sweepFlag = this.sweepFlag ^ (1 << 4)
        }
        if (this.hasControlForm.absorptionWater && this.controlForm.absorptionWater) {
          this.sweepFlag = this.sweepFlag ^ (1 << 3)
        }

        console.log(this.sweepFlag)
      },
      checkLeave() {
        clearInterval(this.timer);
        console.log("离开远程接管页面！");
      },
      initHasControlForm() {
        if (this.carType == 2) { //扫地车
          this.hasControlForm.sprinkle = true
          this.hasControlForm.shockDust = true
          this.hasControlForm.sweep = true
        }
        if (this.carType == 3) { //洗地机
          // this.hasControlForm.sprinkle=true
          // this.hasControlForm.shockDust=true
          this.hasControlForm.washFloor = true
          this.hasControlForm.absorptionWater = true
          this.hasControlForm.security = true
        }
      },
    },
    beforeDestroy() {
      this.checkLeave()
    },
    destroyed() {
      window.removeEventListener('beforeunload', this.checkLeave)
    },
    mounted() {
      this.carId = localStorage.getItem('remoteCarId')
      this.carType = localStorage.getItem('remoteCarType')
      this.initHasControlForm()
      window.addEventListener('beforeunload', this.checkLeave)
      this.rockerInit()
      this.remoteIntevel()
    },
  }
</script>

<style>
  .vjs-icon-placeholder {
    width: 80%;
    height: 80%;
    display: block;
  }

  /* .video-player {
      width: 50%;
    } */
  .videoRow {
    margin: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    padding: 30px;
    text-align: center;
    padding-top: 90px;
    padding-bottom: 30px;

  }

  .controlRow {
    margin: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    padding: 30px;
    text-align: center;
  }

  .remote {
    padding-top: 15px;
    padding-left: 15px;
  }

  .headCarName {
    background-color: #3fb976;
    width: 97%;
    height: 40px;
    color: #FFFFFF;
    line-height: 40px;
    padding-left: 15px;
    border-radius: 10px;
  }

  .front {
    border-radius: 50% !important;
    background: url(../assets/img/shoubing1.png) !important;
    background-size: contain !important;
    opacity: 1 !important;
  }

  .back {
    border-radius: 50% !important;
    background: url(../assets/img/rocker_base.png) !important;
    background-size: contain !important;
    opacity: 1 !important;
  }

  .nipple {
    opacity: 1 !important;
  }

  .show {
    padding-left: 20%;
    width: 50%;
  }

  #videoElement1 {
    /* scale(1.75) translateX(-2px) */
    transform: perspective(600px) rotateY(40deg) scale(1.33) translateX(52px);
    /* transform: perspective(600px) rotateY(40deg) scale(2.4) translateX(170px); */
  }

  /* #videoElement0{

 } */
  #videoElement2 {
    /* transform: rotateY(30); */
    /* transform: perspective(600px) rotateY(40deg) scale(1.4) translateX(-42px) ; */
    transform: perspective(600px) rotateY(-40deg) scale(1.33) translateX(-52px);
  }

  .controlForm {
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  }

  .videos {
    margin:0 auto;
   /* margin-left: 2%; */
    width: 47%;
    height:340px;
    margin-top: -60px;
    border: 1px solid #d6d6d6;
    background-color: #f5f7fa;
  }
</style>
